import { render, staticRenderFns } from "./ClientSells.vue?vue&type=template&id=1d0e2a50"
import script from "./ClientSells.vue?vue&type=script&lang=ts"
export * from "./ClientSells.vue?vue&type=script&lang=ts"
import style0 from "./ClientSells.vue?vue&type=style&index=0&id=1d0e2a50&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports